import React, { useState } from "react";
import LeavesRequestsFilter from "../components/LeavesRequestsFilter";
import BusinessTripRequest from "./components/businessTrip/BusinessTripRequest";
import VacationRequest from "./components/vacation/VacationRequest";
import SickLeaveRequest from "./components/sickLeave/SickLeaveRequest";
import { LeaveTypeChoices } from "utils/choices";
import { Form } from "react-admin";
import { LeaveTypes } from "utils/constants";
import { Grid } from "@mui/material";
import permissions from "app/permissions";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";

const RequestsList = () => {
  const [leaveId, setLeaveId] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [formKey, setFormKey] = useState(0);

  const canRequestBusinessTrips = checkPermission(
    getPermissions(),
    permissions.canRequestBusinessTripsForAllEmployees,
  );

  const leaveTypeChoices = canRequestBusinessTrips
    ? LeaveTypeChoices
    : LeaveTypeChoices.filter(choice => choice.id !== LeaveTypes.BusinessTrip);

  return (
    <Grid container mt={2}>
      <Grid item xs={12}>
        {!showPreview && (
          <LeavesRequestsFilter
            defaultValues={leaveTypeChoices}
            setLeaveId={setLeaveId}
            leaveId={leaveId}
          />
        )}

        {leaveId === LeaveTypes.Vacation && (
          <Form>
            <VacationRequest
              showPreview={showPreview}
              setShowPreview={setShowPreview}
              isCreate={true}
              setLeaveId={setLeaveId}
            />
          </Form>
        )}

        {canRequestBusinessTrips && leaveId === LeaveTypes.BusinessTrip && (
          <BusinessTripRequest
            key={formKey}
            onSuccess={() => setFormKey(k => k + 1)}
            showPreview={showPreview}
            setShowPreview={setShowPreview}
            setLeaveId={setLeaveId}
          />
        )}

        {leaveId === LeaveTypes.SickLeave && (
          <SickLeaveRequest
            key={formKey}
            onSuccess={() => setFormKey(k => k + 1)}
            setLeaveId={setLeaveId}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default RequestsList;
